import { useReducer } from 'react';
import { ConstantValues } from '../../utils/extensions/constantEx'

export const AddressFormInitalState = {
    id: ConstantValues.DefaultContactAddressId,
    address: '',
    district: '',
    pincode: '',
    thaluk: '',
    panchayat: '',
    ward: 0
};

export const NewNurseFormInitalState = {
    id: 0,
    photo_id: 0,
    aadhaar_doc_id: 0,
    relatives: [],
    contacts: [],
    documents: [],
    removed_nurse_doc_ids: [],
    removed_doc_ids: [],
    address1: { ...AddressFormInitalState },
    address2: { ...AddressFormInitalState }
};

export const SelectedNurseJsonInitalState = {
    id: 0,
    photo_id: 0,
    aadhaar_doc_id: 0,
    relatives: [],
    contacts: [],
    documents: [],
    removed_nurse_doc_ids: [],
    removed_doc_ids: [],
    address1: { ...AddressFormInitalState },
    address2: { ...AddressFormInitalState }
};

const NurseFormInitalState = {
    selectedNurseJosn: { ...SelectedNurseJsonInitalState },
    nurseFormValue: { ...NewNurseFormInitalState },
    removedNurseDocIds: [],
    removedDocIds: [],
    salaryPayments: [],
    advancePayments: [],
    advanceReturnPayments: [],
    nurseVacations: []
};

export const NurseFormReducer = (state = NurseFormInitalState, action) => {
    switch (action.type) {

        case "SET_SELECTED_NURSE_JSON":
            return {
                ...state,
                selectedNurseJosn: action.payload.selectedNurseJosn
            }

        case "SET_NURSE_FORM_VALUE":
            return {
                ...state,
                nurseFormValue: action.payload.nurseFormValue
            }

        case "SET_NURSE_CONTACTS":
            return {
                ...state,
                nurseContacts: action.payload.contacts
            }

        case "SET_NURSE_FAMILIES":
            return {
                ...state,
                nurseFamilies: action.payload.families
            }

        case "SET_NURSE_DOCS":
            return {
                ...state,
                nurseDocuments: action.payload.docs
            }

        case "SET_REMOVED_NURSE_DOC_IDS":
            return {
                ...state,
                removedNurseDocIds: action.payload.nurseDocIds
            }

        case "SET_REMOVED_DOC_IDS":
            return {
                ...state,
                removedDocIds: action.payload.docIds
            }

        case "SET_SALARY_PAYMENTS":
            return {
                ...state,
                salaryPayments: action.payload.salaryPayments
            }

        case "SET_ADVANCE_PAYMENTS":
            return {
                ...state,
                advancePayments: action.payload.advPayments
            }

        case "SET_ADVANCE_RETURN_PAYMENTS":
            return {
                ...state,
                advanceReturnPayments: action.payload.advReturnPayments
            }

        case "SET_NURSE_VACATIONS":
            return {
                ...state,
                nurseVacations: action.payload.nurseVacations
            }

        default:
            return { ...state };
    }

}

export const useNurseForm = () => {
    const [nurseFormState, dispatchNurseFormState] = useReducer(NurseFormReducer, NurseFormInitalState);

    const SetSelectedNurseJson = (selectedNurseJosn) => {
        dispatchNurseFormState({
            type: "SET_SELECTED_NURSE_JSON",
            payload: {
                selectedNurseJosn: selectedNurseJosn
            }
        })
    }

    const SetNurseFormValue = (fromValue) => {
        dispatchNurseFormState({
            type: "SET_NURSE_FORM_VALUE",
            payload: {
                nurseFormValue: fromValue
            }
        })
    }

    const SetNurseContacts = (contacts) => {
        dispatchNurseFormState({
            type: "SET_NURSE_CONTACTS",
            payload: {
                nurseContacts: contacts
            }
        })
    }

    const SetNurseFamilies = (families) => {
        dispatchNurseFormState({
            type: "SET_NURSE_FAMILIES",
            payload: {
                nurseFamilies: families
            }
        })
    }

    const SetNurseDocuments = (docs) => {
        dispatchNurseFormState({
            type: "SET_NURSE_DOCS",
            payload: {
                nurseDocs: docs
            }
        })
    }
    
    const SetRemovedNurseDocIds = (nurseDocIds) => {
        dispatchNurseFormState({
            type: "SET_REMOVED_NURSE_DOC_IDS",
            payload: {
                nurseDocIds: nurseDocIds
            }
        })
    }

    const SetRemovedDocIds = (docIds) => {
        dispatchNurseFormState({
            type: "SET_REMOVED_DOC_IDS",
            payload: {
                docIds: docIds
            }
        })
    }

    const SetSalaryPayments = (payments) => {
        dispatchNurseFormState({
            type: "SET_SALARY_PAYMENTS",
            payload: {
                salaryPayments: payments
            }
        })
    }

    const SetAdvancePayments = (payments) => {
        dispatchNurseFormState({
            type: "SET_ADVANCE_PAYMENTS",
            payload: {
                advPayments: payments
            }
        })
    }

    const SetAdvanceReturnPayments = (payments) => {
        dispatchNurseFormState({
            type: "SET_ADVANCE_RETURN_PAYMENTS",
            payload: {
                advReturnPayments: payments
            }
        })
    }

    const SetNurseVacations = (vacations) => {
        dispatchNurseFormState({
            type: "SET_NURSE_VACATIONS",
            payload: {
                nurseVacations: vacations
            }
        })
    }

    return {
        ...nurseFormState,
        SetSelectedNurseJson,
        SetNurseFormValue,
        SetNurseContacts,
        SetNurseFamilies,
        SetNurseDocuments,
        SetRemovedDocIds,
        SetRemovedNurseDocIds,
        SetSalaryPayments,
        SetAdvancePayments,
        SetAdvanceReturnPayments,
        SetNurseVacations
    }
}

